import { AppInputParsedData, AppInputRawData } from "./App.types";
import { BehaviourType } from "entities/App/model/types";
import { ShipmentType, ShipmentTypeKey } from "entities/shared/shipmentCard.types";
import { PlatformIds } from "shared/constants/auth.constants";
import { DEFAULT_LANG } from "shared/constants/common.constants";
import { safeParseInt } from "shared/lib/common.lib";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { isNullable, Nullable } from "shared/lib/typeCheck.lib";
import { isString } from "shared/lib/typeCheck.lib";

const resolveAllowedShipmentTypes = (allowedShipmentTypes?: ShipmentTypeKey[]): ValueOf<typeof ShipmentType>[] => {
  // Only Sea and Air for now.
  const defaultShipmentTypes = [ShipmentType.SEA, ShipmentType.AIR];
  // const defaultShipmentTypes = Object.values(ShipmentType);
  if (!allowedShipmentTypes) {
    return defaultShipmentTypes;
  }

  const validTypes = allowedShipmentTypes
    .filter((type) => type in ShipmentType)
    .map((type) => ShipmentType[type])
    .filter((type) => defaultShipmentTypes.includes(type));

  return validTypes.length ? validTypes : defaultShipmentTypes;
};

const resolveUrlBehaviour = (urlBehaviour?: ValueOf<typeof BehaviourType>): ValueOf<typeof BehaviourType> => {
  if (urlBehaviour && Object.values(BehaviourType).includes(urlBehaviour)) {
    return urlBehaviour;
  }
  return BehaviourType.Query;
};

export const parseAppInputData = (data: Nullable<AppInputRawData>): AppInputParsedData => ({
  lang: data?.lang ?? DEFAULT_LANG,
  platform: isNullable(data?.platform) ? undefined : safeParseInt(String(data.platform), PlatformIds.com),
  hideCardSearch: data?.hideCardSearch === true || data?.hideCardSearch === "true",
  hideCardShippingLine: data?.hideCardShippingLine === true || data?.hideCardShippingLine === "true",
  height: data?.height,
  shadowDom: data?.shadowDom !== false && data?.shadowDom !== "false",
  tokenUrl: data?.tokenUrl ?? undefined,
  allowedShipmentTypes: resolveAllowedShipmentTypes(data?.shipment_type),
  urlBehaviour: resolveUrlBehaviour(data?.urlBehaviour),
  authData: {
    urlFacebook: isString(data?.authData?.urlFacebook) ? data.authData.urlFacebook : "",
    urlGoogle: isString(data?.authData?.urlGoogle) ? data.authData.urlGoogle : "",
    urlApple: isString(data?.authData?.urlApple) ? data.authData.urlApple : "",
  },
});
